import { c as _c } from "react/compiler-runtime";
import { Button } from '@sprd/sprd-component-kit/v2';
import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import { type AdvertisementCardItem, AmplienceImage, AmplienceLinkType } from '@/types/amplience';
import { AmplienceResponsiveImage } from '@/components/ResponsiveImage/AmplienceResponsiveImage';
const IMAGE_WIDTHS = [300, 400, 600, 800];
export type ProductAdvertisementCardProps = AdvertisementCardItem & {
  isLazyLoadingOff?: boolean;
};
export default function ProductAdvertisementCard(props) {
  const $ = _c(22);
  const {
    className,
    cta,
    image,
    title,
    isDesktop,
    isLazyLoadingOff
  } = props;
  let t0;
  if ($[0] !== className) {
    t0 = clsx("flex h-full w-full flex-col justify-between bg-[#000AFF] p-3 md:p-4", className);
    $[0] = className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== image.image) {
    t1 = {
      src: image.image,
      aspectRatio: "3:4",
      sizes: "(min-width: 768px) 40vw, 100vw",
      widths: IMAGE_WIDTHS
    };
    $[2] = image.image;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isLazyLoadingOff ? "eager" : "lazy";
  const t3 = image.altText ?? "";
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex flex-1 items-start justify-center"><div className="relative aspect-[3/4] w-full overflow-hidden rounded-br-[4rem] sm:rounded-br-[6rem] md:rounded-br-[8rem] lg:rounded-br-[10rem]"><AmplienceResponsiveImage className="absolute top-0 left-0 h-full w-full object-cover" source={t1} loading={t2} alt={t3} /></div></div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      textWrap: "balance"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== title) {
    t6 = <div className="py-2 md:py-4"><h3 style={t5} className="text-sm leading-tight font-bold text-white uppercase sm:text-xl lg:max-w-2/3 lg:text-2xl xl:max-w-1/2">{title}</h3></div>;
    $[9] = title;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = isDesktop ? "l" : "s";
  let t8;
  if ($[11] !== cta.label || $[12] !== cta.url) {
    t8 = <Link className="text-center" href={cta.url}>{cta.label}</Link>;
    $[11] = cta.label;
    $[12] = cta.url;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <Button asChild={true} variant="primary" size={t7} className="w-full font-semibold">{t8}</Button>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t0 || $[18] !== t4 || $[19] !== t6 || $[20] !== t9) {
    t10 = <div className={t0}>{t4}{t6}{t9}</div>;
    $[17] = t0;
    $[18] = t4;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}